import { ReactNode, Component } from 'react';

import { createPortal } from 'react-dom';
import { connect } from 'react-redux';

import { getIsMobileHeaderActive } from 'src/selectors/global-selectors';
import { BucketState } from 'src/types/state';

import { SidebarContext } from './context';

type Props = {
  children: ReactNode;
};

class Sidebar extends Component<Props> {
  unsubscribe: () => void;

  /* eslint react/sort-comp: "warn" */
  static contextType = SidebarContext;

  componentDidMount() {
    this.unsubscribe = this.context.onRenderSidebar(() => this.forceUpdate());
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  declare context: any;

  render() {
    const el = document.getElementById('bb-sidebar');
    if (!el) {
      return null;
    }

    return createPortal(this.props.children, el);
  }
}

// eslint-disable-next-line import/no-default-export
export default connect((state: BucketState) => ({
  isMobile: getIsMobileHeaderActive(state),
}))(Sidebar);
